import * as React from "react";
import { Link } from "react-router-dom";

const LeaderShip = () => (
  <div>
    <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
      <h1 className="sm:text-[40px] text-[30px] font-bold">Our Leadership</h1>
    </div>
    <div className="abc mx-auto sm:pt-8 sm:flex grid flex-col gap-7 pt-[4rem] mb-[6rem] px-[auto] sm:px-[10%]">
      <div className="flex flex-col sm:flex-row justify-center items-center sm:items-start w-[100%] gap-7 ">
        <Link to="/founder " className="main-leader w-[60%] sm:w-[25%]">
          <div className="flex flex-col justify-center items-center cursor-pointer">
            <img
              src="/leadershipnew/khalid-nawaz2.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Khalid Nawaz Awan
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              Founder and Chairman
            </p>
          </div>
        </Link>
        <Link to="/saira-awan-malik" className="leader w-[60%] sm:w-[25%]">
          <div className="flex flex-col justify-center items-center cursor-pointer ">
            <img
              src="/leadershipnew/saira_awan2.jpg"
              alt=""
              className="leadership-card w-[100%]"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Saira Awan Malik
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              President
            </p>
          </div>
        </Link>
        <Link to="/qasim-awan" className="leader w-[60%] sm:w-[25%]">
          <div className="flex flex-col justify-center items-center ">
            <img
              src="/leadershipnew/qasim-awan2.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Qasim Awan
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              Executive Director
            </p>
          </div>
        </Link>
        <Link to="/saadia-awan" className="leader w-[60%] sm:w-[25%]">
          <div className="flex flex-col justify-center items-center">
            <img
              src="/leadershipnew/saadia-awaan2.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Saadia Awan
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              Company Director
            </p>
          </div>
        </Link>
      </div>
      <div className="flex flex-col sm:flex-row justify-center items-center sm:items-start w-[100%] gap-7 ">
        {/* <Link to="/hamid-farooq" className="leader w-[60%] sm:w-[22%]">
          <div className="flex flex-col justify-center items-center  rounded ">
            <img
              src="/leadershipnew/hamid-farooq.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Hamid Farooq
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              CEO TCS Private Limited
            </p>
          </div>
        </Link> */}
        <Link to="/HassanRaza" className="leader w-[60%] sm:w-[22%]">
          <div className="flex flex-col justify-center items-center  rounded ">
            <img
              src="/leadershipnew/HassanRazaLeghari4.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Hassan Raza Leghari
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              CEO TCS Private Limited
            </p>
          </div>
        </Link>
        <Link to="/anwaar-nizami" className="leader w-[60%] sm:w-[22%]">
          <div className="flex flex-col justify-center items-center  rounded ">
            <img
              src="/leadershipnew/AnwaarNizami.png"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.7rem] leader text-center leading-none">
              Anwaar Nizami
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              CEO TCS Logistics (Pvt) Limited
            </p>
          </div>
        </Link>

        <Link to="/abdul-qadir-aziz" className="leader w-[60%] sm:w-[22%]">
          <div className="flex flex-col justify-center items-center  rounded ">
            <img
              src="/leadershipnew/abdul-qadir-aziz4.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Abdul Qadir Aziz
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              CEO Intiana Private Limited
            </p>
          </div>
        </Link>
        {/* <Link to="/muneeza-kassim" className='leader w-[60%] sm:w-[22%]'>
          <div className="flex flex-col justify-center items-center">
            <img src="/leadershipnew/muneeza-kassim1.jpg" className='leadership-card muneeza' alt="" />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">Muneeza Kassim</h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">Group Chief Financial Officer</p>
          </div>
        </Link> */}
      </div>
      {/* <div className="flex flex-col sm:flex-row justify-center items-center sm:items-start w-[100%] gap-7 ">
        <Link to="/nasir-nasrullah" className="leader w-[60%] sm:w-[20%]">
          <div className="flex flex-col justify-center items-center ">
            <img
              src="/leadershipnew/brig-(retd.)-nasir-nasrullah.jpg"
              alt=""
              className="leadership-card"
            />
            <h2 className="font-bold text-[1.125rem] md:text-[1.125rem] sm:text-[0.875rem] mt-[.5rem] leader text-center leading-none">
              Brig (Retd) Nasir Nasrullah
            </h2>
            <p className="text-[0.875rem] md:text-[0.875rem] sm:text-[0.75rem] text-center leading-none pt-1">
              Director Risk &amp; Security
            </p>
          </div>
        </Link>
      </div> */}
    </div>
  </div>
);

export default LeaderShip;
